<template>
  <v-col>
    <v-data-table v-if="demandes" :headers="headers" :items="demandes">
      <template v-slot:[`header.validation`]="{ header }">
        {{ header.text }}
        <v-menu offset-y click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon slot="activator" v-bind="attrs" v-on="on"
              ><v-icon small :color="filterValide ? 'info' : ''"
                >mdi-filter</v-icon
              ></v-btn
            >
          </template>
          <v-list>
            <v-checkbox
              dense
              label="en cours"
              v-model="filterValide"
              :value="null"
            ></v-checkbox>
            <v-checkbox
              dense
              label="accepté"
              v-model="filterValide"
              :value="true"
            ></v-checkbox>
            <v-checkbox
              dense
              label="refusé"
              v-model="filterValide"
              :value="false"
            ></v-checkbox>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:[`item.validation`]="{ item }">
        <v-col v-if="item.validation == null" color="warning">
          <v-btn
            color="warning"
            @click="openValidation(item)"
            rounded
            outlined
            small
            >A valider &nbsp;<v-icon small
              >mdi-checkbox-marked-circle-outline</v-icon
            ></v-btn
          >
        </v-col>
        <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
        <v-chip v-else-if="item.validation == 1" color="success"
          >accepté</v-chip
        >
      </template>
    </v-data-table>
    <v-dialog v-model="popUpValidation" persistent>
      <BaseBlock>
        <v-row>
          <iframe
            height="100%"
            width="100%"
            :src="iframeSrc"
            title="PDF Changement de Insee"
          ></iframe>
        </v-row>
        <v-row align="center" justify="center"
          ><div clas="text-center" v-if="!traitementEnCours">
            <v-col align-self="end">
              <v-btn color="success" @click="traitementForm(1)">Accepter</v-btn
              >&nbsp;
              <v-btn color="error" @click="dialogRefus = true">Refuser</v-btn>
              &nbsp;
              <v-btn @click="fermerDialogValidation" color="info"
                ><v-icon>mdi-close</v-icon>Fermer</v-btn
              >
            </v-col>
          </div>
          <div v-else>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular></div
        ></v-row>
      </BaseBlock>
    </v-dialog>
    <v-dialog v-model="dialogRefus" persistent>
      <BaseBlock>
        <v-form v-model="validRefus" ref="formRefus" lazy-validation>
          <v-textarea
            v-model="Insee.messageRefus"
            name="Expliquer le refus de la demande"
            label="Expliquez le refus de la demande"
            :rules="[
              (value) => !!value || 'Champ requis.',
              (v) =>
                (v || '').length <= 4000 ||
                `le nombre de caractères doit être inférieur à 4000.`,
            ]"
            required
            auto-grow
            counter="4000"
          ></v-textarea>
          <v-row align="center" justify="center"
            ><div clas="text-center">
              <v-col align-self="end">
                <v-btn
                  color="success"
                  @click="confirmerDialogRefus"
                  :disabled="!validRefus"
                  >Valider</v-btn
                >
                <v-btn color="error" @click="annulerRefus">annuler</v-btn>
              </v-col>
            </div></v-row
          >
        </v-form>
      </BaseBlock>
    </v-dialog>
  </v-col>
</template>

<script>
import ApiInseeRepository from "@/repositories/ApiInseeRepository";
import BaseBlock from "@/components/base/BaseBlock";

export default {
  components: { BaseBlock },
  data() {
    return {
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Nom du fichier",
          value: "nameFile",
        },
        {
          text: "Statut",
          value: "validation",
        },
      ],
      demandes: null,
      Insee: {
        nameFile: null,
        validation: null,
        messageRefus: null,
        noSIRH: null
      },
      editedIndex: null,
      iframeSrc: null,
      popUpValidation: false,
      traitementEnCours: false,
      validRefus: false,
      dialogRefus: false,
    };
  },
  async created() {
    this.demandes = await ApiInseeRepository.getDemandesGestionnaire();
    console.log(this.demandes);
  },
  methods: {
    async openValidation(item) {
      this.editedIndex = this.demandes.indexOf(item);
      this.Insee = Object.assign({}, item);
      this.iframeSrc = await ApiInseeRepository.getDemandeFileDRH(item.id);
      this.popUpValidation = true;
    },

    fermerDialogValidation() {
      this.iframeSrc = "";
      this.popUpValidation = false;
      if (this.$refs.formRefus)
        this.$refs.formRefus.reset();
    },

    confirmerDialogRefus() {
      if (this.$refs.formRefus.validate()) {
        this.dialogRefus = false;
        this.traitementForm(0);
      }
    },

    annulerRefus() {
      this.formComplementaire.messageRefus = null;
      this.$refs.formRefus.reset();
      this.dialogRefus = false;
    },

    traitementForm(valider) {
        this.$confirm(
          "<b>Confirmez vous votre choix de " +
            (valider == "0" ? "refuser" : "traiter") +
            " la demande ?</b>"
        ).then(async (reponse) => {
          if (reponse) {
            this.finForm = true;
            this.$toast.info("Vous avez confirmé.");

            if (valider == 1) {
              this.Insee.validation = 1;
            } else this.Insee.validation = 0;
            this.$toast.info("Envoie du mail en cours...");
            let updateDemande =
              await ApiInseeRepository.updateDemande(
                this.Insee
              );
            this.finForm = false;
            Object.assign(this.demandes[this.editedIndex], updateDemande);
            this.editedIndex = -1;
            this.Insee = Object.assign({});
            this.$toast.info("Demande mise à jour.");
            this.popUpValidation = false;
            this.iframeSrc = "";
          } else {
            this.$toast.info("Vous n'avez pas confirmé.");
          }
          if (this.$refs.formRefus)
            this.$refs.formRefus.reset();
        });
    },
  },
};
</script>
